import { createReducer, on } from '@ngrx/store';
import { TransactionStatus } from '@rd/types';
import { PromocodeBanner } from '../types';
import * as actions from './promocode-banner.actions';

export interface PromocodeBannerState {
  promocodeBanners: PromocodeBanner[];
  status: TransactionStatus;
}

const initialState: PromocodeBannerState = {
  promocodeBanners: [],
  status: TransactionStatus.INITIAL,
};

export const promocodeBannerReducer = createReducer(
  initialState,
  on(actions.LoadPromocodeBanners, (state) => ({
    ...state,
    status: TransactionStatus.LOADING,
  })),
  on(actions.LoadPromocodeBannersSucces, (state, action) => ({
    ...state,
    promocodeBanners: [...action.promocodeBanners],
    status: TransactionStatus.SUCCESS,
  })),
  on(actions.LoadPromocodeBannersFail, (state) => ({
    ...state,
    status: TransactionStatus.FAIL,
  })),
);
